import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/FlowList.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Popup', {
    attrs: {
      "position": "right",
      "width": "100%",
      "show-mask": _vm.showMask
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox",
    attrs: {
      "body-padding-bottom": 0
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c(__unplugin_components_0, {
      key: index,
      nativeOn: {
        "click": function ($event) {
          _vm.$emit('on-success', item.fk_t_customer_id, item.name), _vm.currValue = false;
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.name))]), _c('div', {
      attrs: {
        "slot": "no"
      },
      slot: "no"
    }, [_vm._v(i18n.tc("345") + _vm._s(item.linkperson))])]);
  }), 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };